import { call, put } from "redux-saga/effects";
import {
  fetchLocationListUpdateSummarySuccess,
  importFileFailed,
  importFileSuccess,
} from "./actions";
import { showErrorNotification } from "src/util/notifications";
import api from "src/util/api";
import {
  LOCATION_LIST_UPDATE_URL,
} from "src/util/constants/api.constants";

export function* fetchLocationListUpdateSummary(p0: {}): Generator {
  try {
    let url = LOCATION_LIST_UPDATE_URL.LOCATION_LIST_UPDATE_SUMMARY_LIST;
    const data: any = yield call(api.get, url);
    yield put(fetchLocationListUpdateSummarySuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function* importLocationListUpdateFile({ payload, actionType }: any): Generator {
  try {
    let url = LOCATION_LIST_UPDATE_URL.LOCATION_LIST_IMPORT;
    const formdata = new FormData();
    formdata.append("file", payload.file);
    formdata.append("UploadedBy", payload.UserName);
    const data: any = yield call(api.post, url, formdata);
    yield put(importFileSuccess(data));
  } catch (e: any) {
    yield put(importFileFailed(e.response.data));
  }
}


